//100vh Fix
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);
window.addEventListener('resize', () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

function focus() {
  $('#header_search_input').focus();
}

$(document).ready(function(){
  
  //Mob Menu Submenu Controls
  $('#mob_menu li.has_submenu a.open_submenu').click(function(e){
    e.preventDefault();
    $(this).parents('.has_submenu').find('.submenu').addClass('active');
  });
  $('#mob_menu .submenu .go_back').click(function(e){
    e.preventDefault();
    $(this).parents('.submenu').removeClass('active');
  });
  $('.toggle_menu').click(function(e){
    e.preventDefault();
    $('body').toggleClass('mob_menu_open');
    $('#mob_menu .submenu').removeClass('active');
  });

  //Tabs
  $('.tab .tab_title').click(function(){
    $(this).parents('.tab').toggleClass('open');
  });

  //Gallery Slideshows
  if ( Modernizr.touchevents ) {
    var $effect = 'slide';
  } else {
    var $effect = 'fade';
  }

  var gallerySwiper;

  $('.gallery .thumbnails a, .single_project .gallery_item a').click(function(e){
    e.preventDefault();
    var $gallery = $(this).parents('.gallery-block').find('.swiper-container');
    var $parent = $(this).parents('.gallery-block');
    var $index = $(this).attr('data-index');
    console.log($index);
    $(this).parents('.gallery-block').find('.popup_gallery').addClass('open');
    gallerySwiper = new Swiper($gallery, {
      loop: true,
      effect: $effect,
      simulateTouch: false,
      lazy: {
        loadPrevNext: true,
      },
       keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      navigation: {
        nextEl: $parent.find('.next'),
        prevEl: $parent.find('.prev'),
      },
      pagination: {
        el: $parent.find('.pagination'),
        type: 'fraction',
      }
    });
    gallerySwiper.slideTo($index,0);

    //Close Gallery
    $('.popup_gallery .close').click(function(e){
      e.preventDefault();
      $(this).parents('.gallery-block').find('.popup_gallery').removeClass('open');
      gallerySwiper.destroy(true,true);
    });

    //Click to Advance
    $gallery.find('.swiper-slide img').click(function(){
      gallerySwiper.slideNext();
    })
  
  });

  //Homepage Slideshow
  function initHomeSwiper() {
    var homeSwiper = new Swiper($('.fullscreen_slideshow .swiper-container'), {
      loop: true,
      effect: 'fade',
      simulateTouch: false,
      speed: 1000,
      lazy: {
        loadPrevNext: true,
      },
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      disableOnInteraction: false,
      navigation: {
        nextEl: '.next',
        prevEl: '.prev',
      },
    });
  }
  initHomeSwiper();
  document.addEventListener("shopify:section:load", function(){
    initHomeSwiper();
  });

  //Press Slideshow
  function initPressSwiper() {
    var pressSwiper = new Swiper($('.press_item .swiper-container.do-init'), {
      loop: true,
      lazy: {
        loadPrevNext: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    });
  }
  initPressSwiper();
  document.addEventListener("shopify:section:load", function(){
    initPressSwiper();
  });

  

  //Product Slideswhow
  const productSwiper = new Swiper('.product_images_mobile.with-swiper .swiper-container', {
    loop: true,
    autoHeight: true,
    lazy: {
      loadPrevNext: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    }
  });

  //Quantity Buttons on Add to Cart
  $('.qty_wrap .plus').click(function(){
    var $number = parseInt($(this).parents('.qty_wrap').find('input').val()) + 1;
    $(this).parents('.qty_wrap').find('input').val($number);
  })
  $('.qty_wrap .minus').click(function(){
    var $number = parseInt($(this).parents('.qty_wrap').find('input').val()) - 1;
    if ( $number > 0 ) {
      $(this).parents('.qty_wrap').find('input').val($number);
    }
  })

  //Cart Drawer
  $('.toggle_cart').click(function(e){
    e.preventDefault();
    $('#side_cart, #cart_mask').toggleClass('open');
  });

  //Ajax Remove Button
  $('body').on('click','.remove_link',function(event){
    event.preventDefault();
    var $variant = $(this).attr('data-variant');
    $('#cart_contents').addClass('loading');

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']=0',
      dataType: 'json',
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count').html(cart.item_count);
        } );
      }
    });
  });

  //Ajax Change Quantity in Cart
  $('body').on('click','.side_cart_quantity',function(event){
    event.preventDefault();
    var $quantity = $(this).attr('data-qty');
    var $variant = $(this).attr('data-variant');
    $('#cart_contents').addClass('loading');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+$variant+']='+$quantity+'',
      dataType: 'json',
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
        //Update Cart Count
        jQuery.getJSON('/cart.js', function(cart) {
          $('.cart-count').html(cart.item_count);
        } );
      }
    });
  });

  $('body').on('focusout','#CartNote0',function(event){
    event.preventDefault();
    var $cartNote = $('#CartNote0').val();
    $('#cart_contents').addClass('loading');
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: {note: $cartNote},
      success: function() {
        //Update Mini Cart
        $('#load_wrapper').load('/ #load', function(){
          $('#cart_contents').removeClass('loading');
        });
      }
    });
  });

  //Macy Masonry
  function initMacy() {
    if ( $('.masonry').length ) {
      var macyInstance = Macy({
       container: '.masonry',
       columns: 2,
       waitForImages: true,
       trueOrder: true,
       margin: {
          x: 30,
          y: 30  
        },
        breakAt: {
          992: {
            margin: {
              x: 15,
              y: 15,
            }
          }
        }
      });
      macyInstance.on(macyInstance.constants.EVENT_IMAGE_COMPLETE, function (ctx) {
        //$('.masonry').addClass('visible');
      });
    }
  }
  initMacy();
  document.addEventListener("shopify:section:load", function(){
    initMacy();
  });
  

});

